import React from "react";
import Chart from "react-apexcharts";

const BarChartRotatedColumns = ({ data, categories, hasData }) => {
  const options = {
    chart: {
      height: 350,
      type: "bar",
    },
    plotOptions: {
      bar: {
        columnWidth: "50%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 2,
    },

    grid: {
      row: {
        colors: ["#fff", "#f2f2f2"],
      },
    },
    xaxis: {
      labels: {
        rotate: -45,
      },
      categories: categories ? categories : [""],
    },
    yaxis: {
      labels: { show: false },
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "horizontal",
        shadeIntensity: 0.25,
        gradientToColors: undefined,
        inverseColors: true,
        opacityFrom: 0.85,
        opacityTo: 0.85,
        stops: [50, 0, 100],
      },
    },
  };
  const series = [
    {
      name: " ",
      data: [0],
    },
  ];

  return (
    <div>
      <Chart
        options={options}
        series={data ? data : series}
        type="bar"
        height="400"
      />
    </div>
  );
};

export default BarChartRotatedColumns;
